/* eslint-disable @typescript-eslint/no-unused-vars */
// in src/Menu.js
import * as React from 'react';
import { MultiLevelMenu } from '@react-admin/ra-navigation';
import { useLogout, useTranslate } from 'react-admin';
import {
  useMediaQuery, Theme, Card, CardContent,
} from '@mui/material';
import { useEffect } from 'react';
import { StyledButton } from './buttons/StyledButton';
import { httpClient } from '../../utils/httpClient';
import { getCurrentCustomer } from '../../lib/currentCustomer';
import { HasRoles } from '../../components/HasRoles';
import {
  getGlobalRolesFromStorage,
  userHasRelationToCustomerId,
} from '../../utils/authProvider';

export const CustomMenu: any = (props: any) => {

  const translate = useTranslate();

  const logout = useLogout();
  const currentCustomer = getCurrentCustomer();
  const [lastCurrentCustomer, setLastCurrentCustomer] = React.useState<string | null>(null);
  const [dealer, setDealer] = React.useState<any>(null);
  const [accessRequestMenuTick, setAccessRequestMenuTick] = React.useState(0);

  const currentCustomerId = currentCustomer?.value || '';
  const globalRoles = getGlobalRolesFromStorage();
  const isGlobalSalesOrSupport = globalRoles.includes('sales_global') || globalRoles.includes('support_global');
  const showRequestCustomerAccessMenu = isGlobalSalesOrSupport 
    && Boolean(currentCustomerId)
    && !userHasRelationToCustomerId(currentCustomerId)
    && accessRequestMenuTick >= 0;

  useEffect(() => {

    if (!lastCurrentCustomer) {

      setLastCurrentCustomer(currentCustomer?.value || null);

    }
    if (lastCurrentCustomer === currentCustomer?.value) {

      return;

    }
    setLastCurrentCustomer(currentCustomer?.value || null);

    const currentDomain = window.location.hostname;
    const splicedDomain = currentDomain.split('.').splice(-2).join('.');
    httpClient(`https://${splicedDomain}/?get_info=${currentCustomer?.value}`, { headers: { Authorization: '' } }).then((response: any) => {

      if (response && response.json?.name) {

        setDealer(response.json);

      } else {

        setDealer(null);

      }

    }).catch(() => {

      setDealer(null);

    });

  }, [currentCustomer, lastCurrentCustomer]);

  useEffect(() => {

    const bump = () => setAccessRequestMenuTick((t) => t + 1);
    window.addEventListener('contextRefreshed', bump);
    return () => window.removeEventListener('contextRefreshed', bump);

  }, []);

  const isLargeEnough = useMediaQuery<Theme>((theme) => theme.breakpoints.up('sm'));

  if (!isLargeEnough) return null;

  return <MultiLevelMenu
    initialOpen={true}
    sx={{
      paddingBottom: '2em',
      height: '100%',
    }}
    {...props}
  >
    <MultiLevelMenu.Item name="dashboard" to={'/'} label="menu.items.dashboard" />
    <HasRoles anyOf={['admin', 'sales_global', 'support_global']}>
      {showRequestCustomerAccessMenu && (
        <MultiLevelMenu.Item
          name="customer-access-request"
          to="/customer-access-requests/new"
          label="menu.items.customer_access_request"
        />
      )}
    </HasRoles>
    <HasRoles anyOf={['admin', 'sales_admin', 'support_admin', 'bhvk_admin', 'bhvk_trial']}>

      <div className={'category'}></div>
      <MultiLevelMenu.Item name="demo" to={'/maak-alarm'} label="menu.items.response" />
      <MultiLevelMenu.Item name="alarms" to={'/alarms?page=1'} label="menu.items.alarms" />

      <div className={'category'}></div>
      <MultiLevelMenu.Item name={'assets'} to={'/assets'} label={'resources.users.text.title'}/>
      <MultiLevelMenu.Item name={'asset-groups'} to={'/asset-groups'} label={'menu.items.groups'}/>
      <HasRoles anyOf={['role_recurring_tasks', 'developer_admin']}>
        <MultiLevelMenu.Item name={'certification-categories'} to={'/certification-categories'} label={'menu.items.certifications'}/>
      </HasRoles>

      <MultiLevelMenu.Item name={'buttons'} to={'/buttons'} label={'resources.devices.text.buttons'}/>
      <HasRoles anyOf={['developer_admin', 'role_recurring_tasks']}>
        <MultiLevelMenu.Item name="security-inventory-items" to="/security-inventory-items" label="menu.items.security_inventory"/>
      </HasRoles>
      <MultiLevelMenu.Item name="report-triggers" to="/report-triggers" label="resources.reports.title"/>
      <MultiLevelMenu.Item name="overlays" to="/overlays" label="resources.overlays.text.title"/>
      <div className={'category'}></div>
      <>
        <MultiLevelMenu.Item name={'order'} to={'/bestellen'} label={'general.text.order'}/>
        <MultiLevelMenu.Item name={'orders'} to={'/bestellingen'} label={'general.text.orders'}/>
      </>

      <div className={'category'}></div>
      <MultiLevelMenu.Item name={'help'} to={'/help'} label={'general.text.help'}/>
      <MultiLevelMenu.Item name={'install'} to={'/help/de-app/hoe-installeer-je-de-bhv-knop-nl-app/'} label={'general.text.install_app'}/>
    </HasRoles>
    {dealer && (
      <Card style={{
        backgroundColor: dealer.color,
        position: 'fixed',
        width: '160px',
        bottom: '55px',
        left: '20px',
      }}>
        <CardContent style={{ paddingBottom: '5px !important' }}>
          <div style={{
            color: dealer.textcolor,
            textAlign: 'center',
            marginTop: '10px',
            marginBottom: '5px',
            fontFamily: '"Barlow Condensed", sans-serif',
            fontSize: '12px',
            textTransform: 'uppercase',
            fontWeight: 700,
          }}>{translate('menu.text.brought_by')}</div>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <img src={dealer.logocolor} alt={dealer.name} style={{ width: '90px' }}/>
          </div>
        </CardContent>
      </Card>
    )}
    <StyledButton
      onClick={logout}
      label="ra.auth.logout"
      color={'primary'}
      style={{
        position: 'fixed',
        bottom: '20px',
        width: '160px',
        left: '20px',
      }}
    />
  </MultiLevelMenu>;

};
